import { IState } from 'shared/store';

export const isErrorPopupOpenedSelector = (state: IState) => state.consultantCianChat.isErrorPopupOpened;
